
export class FoodSafetyList {
    Id: number;
    ZoneName: string;
    Department: string;
    BusinessId: string
    CreatedOn: string;
    CreatedBy: number;
    Status: string;
    Title: string;
    ShowDeviation: boolean;
    UserCount: number;
    FoodSafetyUsers: FoodSafetyUserList[];
}

export class FoodSafetyUserList {
    FoodSafetyId: number;
    UserId: number;
    NameList: string;
}

export class ReasonAfterDealineCompletion{
    Id: number;
    ActivityId: number;
    Reason: string;
}

